import React from "react";
import { useSearchAction } from "src/context/NewPremiseFormContext";
import { SearchFieldResponsive } from "src/components/Form/SearchField";

export const ActionSection = () => {
  const { searchFieldProps } = useSearchAction();
  return <SearchFieldResponsive {...searchFieldProps} />;
};
